import React from "react";
import "./App.css";
import Timeline from "./Timeline";

function App() {
  return (
    <>
      <h1>React Timeline</h1>
      <Timeline />
    </>
  );
}

export default App;
